import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import classnames from 'classnames';

import { Helmet } from 'react-helmet';
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';

import { actions } from '../services/app';

const styled = withStyles(theme => {
  return {
    root: {
      position: 'relative',
      padding: theme.spacing.unit * 2
    },
    pageLoading: {
      height: 'calc(100vh - 56px)',
      [theme.breakpoints.up('sm')]: {
        height: `calc(100vh - 64px)`
      },
      overflow: 'hidden'
    },
    loadingContainer: {
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
});

class Page extends React.Component {
  componentDidMount() {
    this.props.actions.setTitle(this.props.title);
  }

  render() {
    const { children, classes, loading, title } = this.props;
    return (
      <div
        className={classnames(classes.root, { [classes.pageLoading]: loading })}
      >
        <Helmet>
          <title>{title + ' - Kuku'}</title>
        </Helmet>
        {children}
        {loading && (
          <React.Fragment>
            <div className={classes.loadingContainer}>
              <CircularProgress
                color="secondary"
                size={60}
                className={classes.progress}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }
}

// const mapStateToProps = state => {
//   return {

//   };
// };

const mapDispatchToProps = dispatch => ({
  actions: {
    setTitle: title => dispatch(actions.setTitle(title))
  }
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(styled(Page))
);
